import React from 'react';
import { Modal, ModalFooter, ModalBody, ModalHeader, Button, Col } from 'reactstrap';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import GrantsList from './GrantsList';

class GrantsSearch extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            disableGrantsDelete: true,
            disableGrantsAdd: true,
            searchText: ''
        };
    }

    handleGrantsOnSelectionChanged = (ids) => {
        this.grantIds = ids;
        this.setState({ disableGrantsDelete: !ids.length > 0, disableGrantsAdd: ids.length > 0 ? false : true })
    }

    handleAdd = () => {
        this.props.onAdd(this.grantIds);
        this.setState({ disableGrantsDelete: true, disableGrantsAdd: true, searchText: '' });
        this.toggle();
    }

    textChange = (e) => {
        this.setState({
            searchText: e.target.value
        }, () => {
            this.props.onSearch(this.state.searchText)
        })
    }

    cancelClick = () => {
        this.setState({ searchText: '' })
        this.props.toggle()
    }

    toggle = () => {
        this.setState({ searchText: '' })
        this.props.toggle();
    }
    
    render() {
        return (
            <Modal
                scrollable={true}
                isOpen={this.props.isOpen}
                toggle={this.toggle}
                size='lg'
            >
                <ModalHeader toggle={this.toggle}>Grant Search</ModalHeader>
                <ModalBody>
                    <Col className='col-4 align-self-center p-2'>
                        <input type="text" placeholder="Search Grants" value={this.state.searchText} onChange={e => this.textChange(e)} />
                    </Col>
                    <GrantsList
                        data={this.props.data}
                        onSelectionChanged={this.handleGrantsOnSelectionChanged}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" disabled={this.state.disableGrantsAdd} onClick={this.handleAdd}>Add</Button>{' '}
                    <Button color="secondary" onClick={this.cancelClick}>Cancel</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default GrantsSearch